/*
 * @Author: 317473294@qq.com
 * @Date: 2023-10-26 20:03:10
 * @LastEditTime: 2023-10-28 10:33:27
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/router/test.js
 */
import layout from '@/layout/layout'
export const asyRouterList=[
  // {
  //   path: '/home',
  //   name: '数据展示',
  //   icon:"el-icon-s-data",
  //   component: layout,
  //  redirect: '/bigScreen',//子页定向到word页面，输入home,子页面显示word
  //   // hidden: true,
  //   children: [
  //     {
  //       path: "/bigScreen",//主页默认显示单词页面
  //       name: "数据详情",
  //       component: resolve => require(['@/views/bigScreen/bigScreen.vue'], resolve),
  //       meta: { title: '数据详情', icon: 'el-icon-s-data',requiresAuth:true },
  //     },
  //   ]
  // },
  {
    "id": 187,
    "keyid": 3844447,
    "parentid": 0,
    name: "首页",
    "path": "/home",
    component: layout,
    "hideinbread": "0",
    hidden: true,
    "notcache": 0,
    "icon": "el-icon-s-data",
    "sort": 0,
    redirect: '/bigScreen',
    "type": 1,
    "permissionident": "",
    "created_at": "2023-10-21 22:15:10",
    "updated_at": "2023-10-21T14:16:57.000Z",
     children: [
      {
        path: "/bigScreen",//主页默认显示单词页面
        name: "数据详情",
        component: resolve => require(['@/views/bigScreen/bigScreen.vue'], resolve),
        meta: { title: '数据详情', icon: 'el-icon-s-data',requiresAuth:true },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/test.js